export const SLOT_DURATION_CHOICES = [
  { label: '15 minutes', value: '00:15:00' },
  { label: '30 minutes', value: '00:30:00' },
  { label: '60 minutes', value: '01:00:00' },
];

export const SLOT_HEADER_INTERVAL_CHOICES = [
  { label: '30 minutes', value: '00:30:00' },
  { label: '1 hour', value: '01:00:00' },
  { label: '2 hours', value: '02:00:00' },
];

export const TIME_FORMAT_CHOICES = [
  { label: '12 Hour', value: '12h' },
  { label: '24 Hour', value: '24h' },
];
